import React, { FC, JSX } from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { Placement } from "react-bootstrap/types";

interface TooltipDefaultProps extends React.HTMLAttributes<HTMLDivElement> {
  id?: string,
  text?: string | JSX.Element,
  position: Placement;
  backgroundColor?: string
  color?: string
}

const TooltipDefault: FC<TooltipDefaultProps> = ({ id, text, position, children, backgroundColor = '#000', color = "#fff" }) => {
  const entering = (e: any) => {
    e?.children[0]?.style?.setProperty('--bs-tooltip-bg', backgroundColor);
    e.children[1].style.backgroundColor = backgroundColor;
    e.children[1].style.color = color;
  }

  const renderTooltip = (props: any) => (
    <Tooltip id={'tooltip-' + id} {...props}>
      <>{text}</>
    </Tooltip>
  );

  return (
    <div className="TooltipDefault" data-testid="TooltipDefault">
      <OverlayTrigger
        key={'top'}
        placement={position}
        overlay={renderTooltip}
        onEntering={entering}
      >
        <span data-testid="TooltipItem">{children}</span>
      </OverlayTrigger>
    </div>
  );
}

export default TooltipDefault;
